<template>
	<tr @dblclick="onEdit">
		<td class="dense" :class="{'tdGreen': checkClasses['filter_id']}">{{ item.id }}</td>
		<td :class="{'tdGreen': checkClasses['filter_customer']}">{{ item['customer'] }}</td>
		<td :class="{'tdGreen': checkClasses['filter_driver']}">{{ item.driver }}</td>
		<td class="center dense" :class="{'tdGreen': checkClasses['filter_truck']}">{{ item.truck }}</td>
		<td class="center dense" :class="{'tdGreen': checkClasses['filter_amount']}">{{ item.amount }}</td>
		<td class="center dense" :class="{'tdGreen': checkClasses['filter_category']}">{{ item.category }}</td>
		<td class="center dense" :class="{'tdGreen': checkClasses['filter_description']}">{{ item.description }}</td>
		<td width="40" class="center dense" :class="{'tdGreen': checkClasses['filter_pay']}">
			<svg-sprite height="16" width="17" :icon-id="Boolean(item.pause) ? 'not_pay' : 'pay'"></svg-sprite>
		</td>
	</tr>
</template>

<script>
import { formatCurrency } from "@/helper";

export default {
	name: "TableTr",
	props: {
		item: Object,
		permissions: Object,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	},
	methods: {
		getIconColor(value) {
			const color = value ? '#19BC38' : '#8F90A6';
			return `color: ${ color }`;
		},
		onEdit() {
			this.$emit('updateEdit', { scheduled_id: this.item['scheduled_id'], id: this.item.id });
		},
		getTotal(total) {
			return formatCurrency(total);
		},
		onCommentsPopup() {
			const { id, unit, unit_type } = this.item;
			this.$emit('updateCommentsPopup', { id, unit, unit_type });
		}
	}
};
</script>

<style lang="scss" scoped>
@import "tableTr";
</style>

<style lang="scss">
@import "tableTrAll";
</style>
